var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialized)?_c('div',[_c('notifications',{attrs:{"group":"system","position":"top right","ignoreDuplicates":true}}),_c('main',{staticClass:"main"},[_c('router-view')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }